import Base from './Base';
import moment from 'moment';

export default class InterestRegistration extends Base {
    constructor(props) {
        super();
        this.import(props);
    }

    import(props = {}) {
        this.id = this.assign('id', props);
        this.userId = this.assign('userId', props);
        this.campaignId = this.assign('campaignId', props);
        this.status = this.assign('status', props) || 'pending';
        this.notes = this.assign('notes', props);
        
        this.createdAt = props.createdAt ? moment(props.createdAt) : this.createdAt;
        this.updatedAt = props.updatedAt ? moment(props.updatedAt) : this.updatedAt;

        this.user = props.user || null;
    }

    export() {
        return {
            userId: this.userId,
            campaignId: this.campaignId,
            status: this.status,
            notes: this.notes
        }
    }

    // Helper getters for user info
    get userName() {
        if (this.user) {
            return this.user.name || 'N/A';
        }
        return 'N/A';
    }

    get userEmail() {
        return this.user?.email || 'N/A';
    }

    get userPhone() {
        return this.user?.phone || 'N/A';
    }
}
